/** Subgraph symbol → display name overrides. */
const PAIR_NAME_MAP: Record<string, string> = {
  CL:   'WTI',
  HG:   'XCU',
  SPX:  'US500',
  NDX:  'US100',
  DJI:  'US30',
  DAX:  'GER40',
  FTSE: 'UK100',
  HSI:  'HK50',
  NIK:  'JP225',
};

/** Map a raw subgraph symbol to its canonical display name. */
export function normalizePairName(symbol: string): string {
  return PAIR_NAME_MAP[symbol] ?? symbol;
}
